export default __webpack_public_path__ + "static/media/news2.13724aa7.webp";